import { ChangeDetectionStrategy, Component, HostBinding, Inject, ViewEncapsulation } from "@angular/core";
import {
	MAT_LEGACY_SNACK_BAR_DATA as MAT_SNACK_BAR_DATA,
	MatLegacySnackBarRef as MatSnackBarRef,
} from "@angular/material/legacy-snack-bar";
import { select, Store } from "@ngrx/store";
import { SnackBarComponentBase, SnackBarOptions } from "@obg/mat.ui.core";
import { AuthSelector, CoreState } from "@obg/ngx.core";
import { ButtonContent, Icon, IconSelector, UserStates } from "@obg/ngx.core.content";
import { fromMillisecondsToSeconds } from "@obg/ngx.global";
import { PlatformService } from "@obg/ngx.global.evo";
import { combineLatest, Observable, timer } from "rxjs";
import { distinctUntilChanged, map, take } from "rxjs/operators";

@Component({
	selector: "obg-m-argentina-reality-check-snackbar",
	templateUrl: "./argentina-reality-check-snack-bar.component.html",
	styleUrls: ["./argentina-reality-check-snack-bar.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class ArgentinaRealityCheckSnackBarComponent implements SnackBarComponentBase {
	@HostBinding("class.obg-m-argentina-reality-check-snackbar") cssHostClass = true;

	isAuthenticated$ = this.store.select(AuthSelector.isAuthenticated);
	spentTimeIcon$: Observable<Icon | undefined>;
	spentMoneyIcon$: Observable<Icon | undefined>;

	counters = new Map();

	constructor(
		private store: Store<CoreState>,
		private iconSelector: IconSelector,
		@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarOptions,
		public snackBar: MatSnackBarRef<any>,
		private platformService: PlatformService
	) {
		this.spentTimeIcon$ = combineLatest([
			this.store.pipe(select(this.iconSelector.get("alerticons"))),
			this.isAuthenticated$,
		]).pipe(
			distinctUntilChanged(),
			map(([icons, isAuth]) => {
				const filteredIcons = isAuth
					? icons.filter((icon) => icon.userState === UserStates.LoggedIn)
					: icons.filter((icon) => icon.userState !== UserStates.LoggedIn);

				return filteredIcons.find((icon) => icon.key === "responsible-gaming.spent-time-question");
			})
		);

		this.spentMoneyIcon$ = combineLatest([
			this.store.pipe(select(this.iconSelector.get("alerticons"))),
			this.isAuthenticated$,
		]).pipe(
			distinctUntilChanged(),
			map(([icons, isAuth]) => {
				const filteredIcons = isAuth
					? icons.filter((icon) => icon.userState === UserStates.LoggedIn)
					: icons.filter((icon) => icon.userState !== UserStates.LoggedIn);

				return filteredIcons.find((icon) => icon.key === "responsible-gaming.spent-money-question");
			})
		);
	}

	onDismiss() {
		this.snackBar.dismissWithAction();
	}

	getButtonCounter(button: ButtonContent) {
		if (button.delayMs && !this.counters.has(button)) {
			const startWith = fromMillisecondsToSeconds(button.delayMs);

			this.counters.set(
				button,
				this.platformService.forClient(() =>
					timer(0, 1000).pipe(
						map((seconds) => startWith - seconds),
						take(startWith + 1)
					)
				)
			);
		}
		return this.counters.get(button);
	}
}
